// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__jqLaZ","choiceBoxes":"toolbarselects_choiceBoxes__167sc","simpleField":"toolbarselects_simpleField__3JDra"};